import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedUserType, setSelectedUserType] = useState(null);

  const handleUserTypeSelect = (userType) => {
    setSelectedUserType(userType);
    dispatch({
      type: "UPDATE_ROLE_DATA",
      payload: { role: userType },
    });
    navigate("/register", { state: { userType } });
  };
  return { selectedUserType, handleUserTypeSelect };
};
